import { render, staticRenderFns } from "./EditPublishInformation.vue?vue&type=template&id=320bcd30&scoped=true&"
import script from "./EditPublishInformation.vue?vue&type=script&lang=js&"
export * from "./EditPublishInformation.vue?vue&type=script&lang=js&"
import style0 from "./EditPublishInformation.vue?vue&type=style&index=0&id=320bcd30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bcd30",
  null
  
)

export default component.exports